import { QueryResult } from '@apollo/react-common';
import { IntlFormatters } from 'react-intl';

import {
  IGetLoyaltyRollUpTheRimTimelineEventSummaryQuery,
  IGetLoyaltyRollUpTheRimTimelineEventsQuery,
} from 'generated/rbi-graphql';
import { IRollUpTheRim } from 'generated/sanity-graphql';

export enum RUTR_SECTION {
  PLAY_NOW = "PLAY_'NOW",
  TIMELINE = 'TIMELINE',
  PRIZES = 'PRIZES',
  WINNERS = 'WINNERS',
  DETAILS = 'DETAILS',
}

export enum RutrModalSectionTypes {
  Timeline = 'timeline',
  Prizes = 'prizes',
  Winners = 'winners',
  Share = 'share',
  InvalidLink = 'invalidLink',
  SharedRollsPage = 'sharedRolls',
  UserIsBlocked = 'userIsBlocked',
  VoucherModal = 'voucherModal',
}

export enum MajorPrizes {
  WIN_CHILLYMOOSE_CODE = 'win-chillymoose-code',
  WIN_CHILLYMOOSE_ICEBOX = 'win-chillymoose-icebox',
  WIN_CINEPLEX_DISCOUNT = 'win-cineplex-discount',
  WIN_CINEPLEX_GRAND = 'win-cineplex-grand',
  WIN_HILTON_6NIGHT = 'win-hilton-6night',
  WIN_HILTON_WEEKEND = 'win-hilton-weekend',
  WIN_100_HOME_HARDWARE = 'win-100-home-hardware',
  WIN_HOME_HARDWARE_COMBO = 'win-home-hardware-combo',
  WIN_GAS_GIFTCARD = 'win-gas-giftcard',
  WIN_5C_JOURNIE = 'win-5c-journie',
  WIN_MM_CODE = 'win-M&M-code',
  WIN_PARKS_DISCOVERYPASS = 'win-parks-discoverypass',
  WIN_PKG_CODE = 'win-pkg-code',
  WIN_PKG_DISCOUNT = 'win-pkg-discount',
  WIN_RAKUTEN_100 = 'win-rakuten-100',
  WIN_RAKUTEN_50 = 'win-rakuten-50',
  WIN_RAKUTEN_25 = 'win-rakuten-25',
  WIN_RAKUTEN_10 = 'win-rakuten-10',
  WIN_SAMSUNG_TAB = 'win-samsung-tab',
  WIN_SAMSUNG_PHONE = 'win-samsung-phone',
  WIN_SXM_CODE = 'win-SXM-code',
  WIN_SXM_SUBSCRIPTION = 'win-SXM-subscription',
  WIN_SKULLCANDY_HEADSET = 'win-skullcandy-headset',
  WIN_SKULLCANDY_EARBUDS = 'win-skullcandy-earbuds,',
  WIN_SPORTSNET_CODE = 'win-sportsnet-code',
  WIN_SPORTSNET_CODE_PREMIUM = 'win-sportsnet-code-premium',
  WIN_SPOTIFY_CODE = 'win-spotify-code',
  WIN_ATHLETIC_SUB_STANDARD = 'win-athletic-sub-standard',
  WIN_ATHLETIC_SUB_GRAND = 'win-athletic-sub-grand',
  WIN_10_THEBAY = 'win-10-thebay',
  WIN_100_THEBAY = 'win-100-thebay',
  WIN_UBEREATS_CODE = 'win-ubereats-code',
  WIN_UBEREATS_5 = 'win-ubereats-5',
  WIN_UBEREATS_40 = 'win-ubereats-40',
  WIN_UNIVERSAL = 'win-universal',
  WIN_VOILA_100 = 'win-voila-100',
  WIN_VOILA_SUBSCRIPTION = 'win-voila-subscription',
  WIN_VOILA_10 = 'win-voila-10',
  WIN_VOILA_15 = 'win-voila-15',
  WIN_VOILA_TIMS = 'win-voila-tims',
  WIN_TAOS = 'win-taos',
  WIN_XBOX = 'win-xbox',
  WIN_XBOX_PASS = 'win-xbox-pass',
  WIN_FORD_USA = 'win-ford-USA',
  WIN_UNIVERSAL_STUDIOS_USA = 'win-universal-studios-USA',
  WIN_XBOX_USA = 'win-xbox-USA',
  WIN_GRUBHUB_USA = 'win-grubhub-USA',
  WIN_SAMSUNG_4KTV_USA = 'win-samsung-4ktv-USA',
  WIN_SAMSUNG_TAB_USA = 'win-samsung-tab-USA',
  WIN_SKULLCANDY_SLYR_USA = 'win-skullcandy-slyr-USA',
  WIN_SKULLCANDY_DISCOUNT_USA = 'win-skullcandy-discount-USA',
  WIN_SXM_6MONTH_USA = 'win-sxm-6month-USA',
  WIN_SXM_4MONTH_USA = 'win-sxm-4month-USA',
  WIN_ATHLETIC_3MONTH_USA = 'win-athletic-3month-USA',
  WIN_ATHLETIC_1YEAR_USA = 'win-athletic-1year-USA',
}

export enum OfferPrizes {
  WIN_COFFEE = 'win-coffee',
  WIN_DONUT = 'win-donut',
  WIN_100_POINTS = 'win-100-points',
  WIN_120_POINTS = 'win-120-points',
  WIN_200_POINTS = 'win-200-points',
  WIN_COLDBEV_USA = 'win-coldbev-USA',
  WIN_COFFEE_USA = 'win-coffee-USA',
  WIN_DONUT_USA = 'win-donut-USA',
  WIN_100_POINTS_USA = 'win-100-points-USA',
  WIN_250_POINTS_USA = 'win-250-points-USA',
  WIN_500_POINTS_USA = 'win-500-points-USA',
}

export enum UnluckyPrizes {
  WIN_DAILY_DRAW_BALLOT = 'win-daily-draw-ballot',
  WIN_DAILY_DRAW_BALLOT_USA = 'win-daily-draw-ballot-USA',
}

export enum GiftCards {
  WIN_25_TIMSCARD = 'win-25-timcard',
  WIN_25_TIMCARD_USA = 'win-25-timcard-USA',
}

export enum TimelineEventType {
  BALLOT = 'ballot',
  ROLL = 'roll',
  PRIZE = 'prize',
  SHARED = 'shared',
}

type OpenModal = {
  section: RutrModalSectionTypes | null;
  isTabbedModal?: boolean;
  modalTitle?: string;
};

export type OpenRutrModal = (arg: OpenModal) => () => void;

export type TimelineType = QueryResult<IGetLoyaltyRollUpTheRimTimelineEventsQuery>;

export interface IContainer {
  /**
   * Margin to add to the top. Useful when working with the header
   *
   * @default 0
   **/
  topOffset?: number;
}

export interface IPlayNowProps {
  setActiveSection: React.Dispatch<React.SetStateAction<RUTR_SECTION>>;
  initiateGameplayRoll: VoidFunction;
  rollUpTheRim: IRollUpTheRim;
  timelineSummary: IGetLoyaltyRollUpTheRimTimelineEventSummaryQuery | undefined;
  startGameplay: (referenceId: string) => void;
  timeline: TimelineType;
  openModal: OpenRutrModal;
  timelineIsLoading: boolean;
  isAuthenticated: boolean;
}

export interface ICurrentPage extends IPlayNowProps {
  activeSection: RUTR_SECTION;
  formatMessage: IntlFormatters['formatMessage'];
}
